import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'

import { HelperWrapper, ModalWrapper } from 'src/components'
import { ETransactionType, ETranslationNs, ITransactionLogDto } from 'src/types'

import { useStyles } from './styles'
import { BlockIcon } from 'src/assets/icons/v2/BlockIcon'
import { HashIcon } from 'src/assets/icons/v2/HashIcon'
import { ArrowFromIcon } from 'src/assets/icons/v2/ArrowFromIcon'
import { ArrowToIcon } from 'src/assets/icons/v2/ArrowToIcon'
import { ExternalLink } from 'src/assets/icons/v2/ExternalLink'
import { EmptyUserIcon } from 'src/assets/icons/v2/EmptyUserIcon'

interface IProps {
  open: boolean
  handleClose: () => void
  formValues: ITransactionLogDto | null
}

export const TxLogFormModal = ({ open, handleClose, formValues }: IProps) => {
  const classes = useStyles()
  const isTest = String(process.env.REACT_APP_STATUS_ENV) !== 'prod'

  const handleHash = (param: string) => {
    if (isTest) {
      if (formValues?.type === ETransactionType.Arweave) {
        window.open(`https://arweave.net/${param}`, '_blank')
      } else {
        window.open(`https://sepolia.basescan.org/tx/${param}`, '_blank')
      }
    } else {
      if (formValues?.type === ETransactionType.Arweave) {
        window.open(`https://arweave.net/${param}`, '_blank')
      } else {
        window.open(`https://basescan.org/tx/${param}`, '_blank')
      }
    }
  }

  const handleAddr = (param: string) => {
    if (isTest) {
      window.open(`https://sepolia.basescan.org/address/${param}`, '_blank')
    } else {
      window.open(`https://basescan.org/address/${param}`, '_blank')
    }
  }

  if (!formValues) {
    return null
  }

  let values: [string, any][] | null = null
  try {
    values = Object.entries(JSON.parse(formValues.data!))
  } catch {}

  return (
    <ModalWrapper open={open} className={classes.modalWrapper} onClose={handleClose}>
      <div className={classes.tableHeader}>
        <BlockIcon size={80} />
        <Typography className={classes.title}>
          <HelperWrapper t="log-header-title" />
        </Typography>
      </div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" width="20%">
                <HelperWrapper t="tx-logs-field-column" ns={ETranslationNs.TransactionLogs} />
              </TableCell>
              <TableCell align="center" width="60%">
                <HelperWrapper t="tx-logs-value-column" ns={ETranslationNs.TransactionLogs} />
              </TableCell>
              <TableCell align="center" width="20%">
                <HelperWrapper t="medial-link-table-column" />
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row" width="20%">
                <div className={classes.cellDisplay}>
                  <HashIcon size={20} />
                  <div>Hash:</div>
                </div>
              </TableCell>
              <TableCell width="60%">{formValues.hash}</TableCell>
              <TableCell width="20%" align="center">
                <div className={classes.button} onClick={() => handleHash(formValues.hash)}>
                  <ExternalLink size={20} />
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                <div className={classes.cellDisplay}>
                  <ArrowFromIcon size={20} />
                  <div>From:</div>
                </div>
              </TableCell>
              <TableCell>{formValues.from || <EmptyUserIcon size={24} />}</TableCell>
              <TableCell width="20%" align="center">
                {formValues.from && (
                  <div className={classes.button} onClick={() => handleAddr(formValues.from!)}>
                    <ExternalLink size={20} />
                  </div>
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th" scope="row">
                <div className={classes.cellDisplay}>
                  <ArrowToIcon size={20} />
                  <div>To:</div>
                </div>
              </TableCell>
              <TableCell>{formValues.to || <EmptyUserIcon size={24} />}</TableCell>
              <TableCell width="20%" align="center">
                {formValues.to && (
                  <div className={classes.button} onClick={() => handleAddr(formValues.to!)}>
                    <ExternalLink size={20} />
                  </div>
                )}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell width="20%" align="center" />
              <TableCell width="60%">
                {values!.map(([key, val]) => (
                  <div className={classes.codeWrapper}>
                    <p className={classes.keyStyle}>"{key}":</p>
                    <p className={classes.valStyle}>
                      "{typeof val === 'object' ? JSON.stringify(val) : val.toString()}"
                    </p>
                  </div>
                ))}
              </TableCell>
              <TableCell width="20%" align="center" />
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </ModalWrapper>
  )
}
